import instance from "@/utils/require.js"

// 错误代码 —— 导入错误代码
export function apiErrorCodeImport(data = {}) {
	return instance({
		url: "/aim/api/v3/error_code/import",
		method: "post",
		data
	})
}
// 错误代码 —— 错误代码分页查询
export function apiErrorCodeSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/error_code/search",
		method: "post",
		data
	})
}

// 型号管理 —— 产品类别列表
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 错误代码 —— 错误代码类别
export function apiErrorCodeTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/error_code_type",
		method: "post",
		data
	})
}

// 错误代码 —— 新增错误代码
export function apiErrorCodeAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/error_code/add",
		method: "post",
		data
	})
}

// 错误代码 —— 修改错误代码
export function apiErrorCodeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/error_code/update",
		method: "post",
		data
	})
}

// 错误代码 —— 修改错误代码
export function apiErrorCodeDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/error_code/delete",
		method: "post",
		data
	})
}

// 错误代码 —— 导出
export function apiErrorCodeExport(data = {}) {
	return instance({
		url: "/aim/api/v3/error_code/export",
		method: "post",
		data
	})
}